import { useCallback } from 'react';
import PortalAppService from '../../../application/platform/portal-app-service';
import { useUsefulLinksDispatch } from './useful-links-context';
import { IListUsefulLinksRequest } from '../../../model/base/request/list-useful-links-request';

export function useUsefulLinksController() {
  const dispatch = useUsefulLinksDispatch();

  const loadCategories = useCallback(async () => {
    try {
      const categories = await PortalAppService.requestLinkCategories();
      dispatch({ type: 'SET_CATEGORIES', payload: categories });
    } catch (error) {
      console.error('Error loading categories:', error);
    }
  }, [dispatch]);

  const loadLinks = useCallback(async (params: IListUsefulLinksRequest) => {
    try {
      dispatch({ type: 'SET_LOADING', payload: true });
      dispatch({ type: 'SET_ERROR', payload: null });

      const response = await PortalAppService.requestUsefulLinks(params);
      dispatch({ type: 'SET_LINKS', payload: response.items || [] });
    } catch (error) {
      console.error('Error loading useful links:', error);
      dispatch({ type: 'SET_ERROR', payload: 'Erro ao carregar os links úteis.' });
    }
  }, [dispatch]);

  return {
    loadCategories,
    loadLinks,
  };
}
